mutation CreateLink($input: CreateLinkInput!) {
  createLink(input: $input) {
    id
    title
    url
    slug
    linkType
    href
    targetType
    targetId
    targetTitle
    url
    targetUrl
    utmSource
    utmMedium
    utmCampaign
    reward {
      type
      percent
      fixedAmount
      fixedCurrency
    }
    createdAt
    updatedAt
  }
}
